<!-- @format -->

<button
	[ngClass]="{
		'hmf-position-relative': true,
		disabled: disabled(),
		selected: selected(),
		'plp-image-swatch-selected': imageSwatchHoverDimension()
	}"
	[attr.aria-label]="swatchAriaLabel"
	[ngStyle]="{ 'border-radius': radius() }"
	(click)="attributeValueClicked($event.currentTarget)">
	<img
		loading="lazy"
		[src]="imageSrc()"
		[ngClass]="{ selected: selected() }"
		[ngStyle]="{
			height: height(),
			width: width(),
			'border-radius': radius()
		}"
		[alt]="altText()"
		(error)="emitImageError($event)" />
</button>
